import script from "./ActivityHeatmap.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityHeatmap.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityHeatmap.vue?vue&type=style&index=0&id=2d443795&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d443795"]])

export default __exports__